import { all, takeEvery, put, fork } from "redux-saga/effects";
import { push } from "react-router-redux";

import * as actionTypes from "../actions/actionTypes";
import * as actions from "../actions/index";
import * as API from "../api";

// Helper
import Helper from "../../helpers/Helper";

export function* loadCart() {
  yield takeEvery(actionTypes.MALL_LOAD_CART, function*(action) {
    try {
      const response = yield API.mallILoadCart();
      if (response.data.success) {
        yield put(actions.mallLoadCartSuccess(response.data));
      } else {
        alert("Warning: Fail to load cart. \n" + response.data.message);
        yield put(actions.mallLoadCartFail());
      }
    } catch (error) {
      yield put(actions.handleAPIError(error, "Fail to load cart. \n"));
      yield put(actions.mallLoadCartFail());
    }
  });
}

export function* insertToCart() {
  yield takeEvery(actionTypes.MALL_INSERT_TO_CART, function*(action) {
    try {
      const response = yield API.mallInsertToCart(
        action.shopID,
        action.productID,
        action.data
      );
      if (response.data.success) {
        let reloadProduct = true;

        if (response.data.data.status) {
          if (action.addType !== "buyNow") {
            yield put(actions.toastSuccess(response.data.message));
          }
          yield put(actions.mallInsertToCartSuccess());
          yield put(actions.mallLoadCart());
        } else {
          if (response.data.data.canProceed) {
            let params = action.data;

            // If price update, confirmation add to cart with updated price
            if (response.data.data.type === "price") {
              const confirm = window.confirm(
                `${response.data.data.title}! ${response.data.data.msg}`
              );

              params.price = response.data.data.value;

              if (confirm) {
                params.track_no = Helper.generateTrackNo("mallCart");

                yield put(
                  actions.mallInsertToCart(
                    action.shopID,
                    action.productID,
                    params
                  )
                );
              }
            } else {
              // If quantity updated
              alert(`${response.data.data.title}! ${response.data.data.msg}`);
            }
          } else {
            alert(`${response.data.data.title}! ${response.data.data.msg}`);

            if (response.data.data.unpublish) {
              reloadProduct = false;
              yield put(push("/mall/product/list"));
            }
          }
        }

        if (reloadProduct) {
          yield put(
            actions.mallGetProductDetail(action.shopID, action.productID)
          );
        }
      } else {
        alert("Warning: Fail to add item to cart. \n" + response.data.message);
        yield put(actions.mallInsertToCartFail());
      }
    } catch (error) {
      yield put(actions.handleAPIError(error, "Fail to add item to cart. \n"));
      yield put(actions.mallInsertToCartFail());
    }
  });
}

export function* deleteFromCart() {
  yield takeEvery(actionTypes.MALL_DELETE_FROM_CART, function*(action) {
    try {
      const response = yield API.mallDeleteFromCart(action.data);
      if (response.data.success) {
        yield put(actions.toastSuccess(response.data.message));
        yield put(actions.mallDeleteFromCartSuccess());
        yield put(actions.mallLoadCart());
      } else {
        alert(
          "Warning: Fail to delete item from cart. \n" + response.data.message
        );
        yield put(actions.mallInsertToCartFail());
      }
    } catch (error) {
      yield put(
        actions.handleAPIError(error, "Fail to delete item from cart. \n")
      );
      yield put(actions.mallDeleteFromCartFail());
    }
  });
}

export function* updateCartItem() {
  yield takeEvery(actionTypes.MALL_UPDATE_CART_ITEM, function*(action) {
    try {
      const response = yield API.mallUpdateCartItem(
        action.shopID,
        action.cartID,
        action.data
      );
      if (response.data.success) {
        yield put(actions.mallUpdateCartItemSuccess());
        yield put(actions.mallLoadCart());
      } else {
        alert("Warning: Fail to update cart item. \n" + response.data.message);
        yield put(actions.mallUpdateCartItemFail());
      }
    } catch (error) {
      alert(API.constructErrMsg(error));
      yield put(actions.mallUpdateCartItemFail());
      yield put(actions.mallLoadCart());
    }
  });
}

export default function* mallCartSaga() {
  yield all([
    fork(loadCart),
    fork(insertToCart),
    fork(deleteFromCart),
    fork(updateCartItem)
  ]);
}
